import dayjs from "dayjs";
import dayjsBusinessTime from "dayjs-business-time";

export const getBankAccountDescription = (account?: {
  type?: "checking" | "savings";
  account_number?: string;
}) => {
  if (!account) return "";
  return `${getBankAccountTypeLabel(
    account.type
  )} •••${account.account_number?.slice(-4)}`;
};

export const getBankAccountTypeLabel = (
  type: "checking" | "savings" | undefined
) => {
  switch (type) {
    case "checking":
      return "Checking";
    case "savings":
      return "Savings";
    default:
      return "";
  }
};

export const getBankAccountTransferEstimatedDate = (): string => {
  dayjs.extend(dayjsBusinessTime);
  const now = dayjs();
  const estimatedDay = now.addBusinessDays(3).format("ddd, MMM D");
  return estimatedDay;
};
